import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { TagsViewModule } from '@/store/modules/tags-view';
import router from '@/router';
import { Action } from 'vuex-module-decorators';
import { getUnits } from '@/api/locations/units';
import { getQuery } from '@/utils';
import { getProducts, searchProducts } from '@/api/products';
import { AdminModule } from '@/store/modules/admin';
import { getAdmins } from '@/api/admins';
import { getInventoryInwardsOld } from '@/api/inventory-inwards';
import { manageInventoryInwardsLog } from '@/api/inventory-inwards-logs';
import { isUnitManager } from '@/common';
let default_1 = class default_1 extends Vue {
  constructor() {
    super(...arguments);
    this.formData = {};
    this.inventoryInwardsLogs = [];
    this.loading = false;
    this.loggedInAdmin = null;
    this.unitManagers = [];
    this.unitList = [];
    this.productList = [];
    this.counter = 1;
    this.selectedProductIds = [];
    this.emptyInventoryInwardsLogs = {
      id: 0,
      productId: null,
      product: null,
      productsVariationId: null,
      productsVariation: null,
      quantity: 0,
      looseQuantity: 0,
      cartonQuantity: 0,
      masterCarton: 0,
      inventoryInwardId: null,
      inventoryInward: null,
      unitId: 0,
      unit: null,
      adminId: 0,
      admin: null,
      // extra cols
      currentStock: 0,
      rowSpan: 1
    };
    this.rules = {
      entryDate: {
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      },
      adminId: {
        required: true,
        message: 'Please select Unit Manager',
        trigger: 'blur'
      },
      unitId: {
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      }
    };
  }
  get lang() {
    return AppModule.language;
  }
  activated() {
    this.loggedInAdmin = AdminModule;
    this.formData.entryDate = new Date();
    this.inventoryInwardsLogs = [];
    this.selectedProductIds = [];
    this.productList = [];
    this.$nextTick(() => {
      // get unit managers
      this.fetchUnitManagers();
      //  get units
      this.fetchUnitList();
    });
    this.tempTagView = Object.assign({}, this.$route);
  }
  _isUnitManager() {
    return isUnitManager();
  }
  async fetchUnitManagers() {
    let managerUnitId;
    // if adding & logged in user is unit manager
    // if (!this.isEdit && this.loggedInAdmin.adminsRoleId === 3) {
    if (!this.isEdit && isUnitManager()) {
      managerUnitId = this.loggedInAdmin.id;
      // set to form data
      this.formData.adminId = this.loggedInAdmin.id;
    }
    // if editing, then get saved unit manager id
    if (this.isEdit) {
      managerUnitId = this.formData.adminId;
    }
    const result = await getAdmins(getQuery({
      id: managerUnitId,
      enabled: true,
      adminsRoleId: 3,
      filter: {
        id: '$eq',
        enabled: '$eq',
        adminsRoleId: '$in'
      }
    }));
    this.unitManagers = result.data;
  }
  async fetchUnitList() {
    try {
      // reset
      this.resetTable();
      // empty check adminId
      if (!this.formData.adminId) {
        return;
      }
      this.unitList = await getUnits(getQuery({
        enable: true,
        'admin.id': this.formData.adminId,
        sort: 'name,ASC',
        filter: {
          enabled: '$eq',
          'admin.id': '$in'
        },
        select: ['id', 'name', 'code'].join(',')
      }));
    } catch (err) {} // eslint-disable-line  no-empty
  }
  async fetchProductList(query) {
    try {
      if (query.length > 2) {
        this.productList = await searchProducts(getQuery({
          keyword: query
        }));
      }
    } catch (err) {} // eslint-disable-line  no-empty
  }
  resetTable() {
    // reset data
    this.inventoryInwardsLogs = [Object.assign({}, this.emptyInventoryInwardsLogs)];
    this.counter = 1;
  }
  setTagsViewTitle(title) {
    const tagView = this.tempTagView;
    if (tagView) {
      tagView.title = `${title}`;
      TagsViewModule.updateVisitedView(tagView);
    }
  }
  setPageTitle(title) {
    document.title = `${title}`;
  }
  submitForm() {
    this.$refs.formData.validate(valid => {
      if (valid) {
        this.saveForm();
      } else {
        return false;
      }
    });
  }
  async saveForm() {
    try {
      this.loading = true;
      // clear empty rows where product is not selected or quantity is 0
      this.inventoryInwardsLogs = this.inventoryInwardsLogs.filter(row => row.productId && row.quantity);
      // remove product, productsVariation, unit, admin, inventoryInward
      this.inventoryInwardsLogs = this.inventoryInwardsLogs.map(row => {
        const newRow = Object.assign({}, row);
        delete newRow.product;
        delete newRow.productsVariation;
        delete newRow.unit;
        delete newRow.admin;
        delete newRow.inventoryInward;
        return newRow;
      });
      // check if empty
      if (!this.inventoryInwardsLogs.length) {
        this.$notify({
          title: 'Error',
          message: 'Please add at least one product',
          type: 'error',
          duration: 4000
        });
        this.resetTable();
        return;
      }
      // save
      await manageInventoryInwardsLog(this.inventoryInwardsLogs);
      this.$notify({
        title: 'Success',
        message: 'Inventory added',
        type: 'success',
        duration: 2000
      });
      this.loading = false;
      router.push('/inventory-inwards/list');
    } catch (err) {
      if (err instanceof Error) {
        this.$notify({
          title: 'Error',
          message: err.message,
          type: 'error',
          duration: 4000
        });
        return;
      }
    } finally {
      this.loading = false;
    }
  }
  async fetchProducts(query) {
    try {
      if (query.length > 2) {
        this.productList = await getProducts(getQuery({
          enable: true,
          limit: 10,
          filter: {
            enabled: '$eq'
          }
        }));
      }
    } catch (err) {} // eslint-disable-line  no-empty
  }
  async productSelected(rowScope, rowIndex) {
    // check if selected product already added
    if (this.selectedProductIds.includes(rowScope.productId)) {
      this.$notify({
        type: 'warning',
        title: 'Duplicate entry',
        message: 'Product already added to list'
      });
      this.inventoryInwardsLogs[rowIndex].productId = null;
      return false;
    } else {
      this.selectedProductIds.push(rowScope.productId);
    }
    // get current inventoryInward based on unitId && product.id which gives productVariationId & currentStock
    const currentProductInventory = await getInventoryInwardsOld(getQuery({
      limit: 100,
      unitId: this.formData.unitId,
      productId: rowScope.productId,
      filter: {
        unitId: '$eq',
        productId: '$eq'
      },
      select: ['id', 'productsVariationId', 'currentStock'].join(',')
    }));
    // get product from product list
    const product = this.productList.find(p => p.id === rowScope.productId);
    // create new row for each variation with same product
    product.productsVariation.forEach((variation, variationIndex) => {
      // get current stock
      const currentStock = currentProductInventory.find(cpi => cpi.productsVariationId === variation.id);
      // modify 0th row
      if (variationIndex === 0) {
        // set unit id
        this.inventoryInwardsLogs[rowIndex].unitId = this.formData.unitId;
        // set admin id
        this.inventoryInwardsLogs[rowIndex].adminId = this.formData.adminId;
        // set product
        this.inventoryInwardsLogs[rowIndex].product = product;
        // set product id
        this.inventoryInwardsLogs[rowIndex].productId = product.id;
        // set product variation
        this.inventoryInwardsLogs[rowIndex].productsVariation = variation;
        // set product variation id
        this.inventoryInwardsLogs[rowIndex].productsVariationId = variation.id;
        // set master carton
        this.inventoryInwardsLogs[rowIndex].masterCarton = product.masterCarton;
        // set current stock
        this.inventoryInwardsLogs[rowIndex].currentStock = currentStock && currentStock.currentStock ? currentStock.currentStock : 0;
        // set id
        // this.inventoryInwardsLogs[rowIndex].id =
        //   currentStock && currentStock.id ? currentStock.id : 0;
        // set rowSpan
        this.inventoryInwardsLogs[rowIndex].rowSpan = product.productsVariation.length;
      }
      // since 0th row is already created
      if (variationIndex > 0) {
        // insert new row at row rowIndex + i
        this.inventoryInwardsLogs.splice(rowIndex + variationIndex, 0, {
          // id: currentStock && currentStock.id ? currentStock.id : 0,   // SB
          id: 0,
          productId: variation.productId,
          product: {
            id: variation.productId
          },
          productsVariationId: variation.id,
          productsVariation: variation,
          unitId: this.formData.unitId,
          unit: {
            id: this.formData.unitId
          },
          adminId: this.formData.adminId,
          admin: {
            id: this.formData.adminId
          },
          quantity: 0,
          looseQuantity: 0,
          cartonQuantity: 0,
          masterCarton: product.masterCarton,
          currentStock: currentStock && currentStock.currentStock ? currentStock.currentStock : 0,
          inventoryInwardId: null,
          inventoryInward: null,
          rowSpan: 0
        });
      }
    });
  }
  quantityChanged(rowData) {
    // calculate quantity
    rowData.quantity = rowData.cartonQuantity * rowData.masterCarton + rowData.looseQuantity;
  }
  doProductRowSpan(args) {
    const {
      row,
      column,
      rowIndex,
      columnIndex
    } = args;
    // check if columnIndex is 0 || 6
    if (columnIndex === 0 || columnIndex === 6) {
      return {
        rowspan: row.rowSpan,
        colspan: 1
      };
    }
    return {
      rowspan: 1,
      colspan: 1
    };
  }
  addProduct() {
    this.counter += 1;
    // restrict upto 5 rows
    if (this.counter > 5) {
      this.counter -= 1;
      this.$notify({
        title: 'Warning',
        message: 'You can add upto 5 products only',
        type: 'warning'
      });
      return false;
    }
    this.inventoryInwardsLogs.push(Object.assign({}, this.emptyInventoryInwardsLogs));
  }
  deleteProduct(index, row) {
    this.inventoryInwardsLogs.splice(index, row.rowSpan);
    // remove from selected product ids array
    const indexToRemove = this.selectedProductIds.indexOf(row.productId);
    this.selectedProductIds.splice(indexToRemove, 1);
    this.counter -= 1;
  }
};
__decorate([Prop({
  default: false
})], default_1.prototype, "isEdit", void 0);
__decorate([Action], default_1.prototype, "saveForm", null);
default_1 = __decorate([Component({
  name: 'InventoryInwardDetail',
  components: {}
})], default_1);
export default default_1;